var _excluded = ["className", "disabled", "defaultValue", "value", "onChange", "showCount", "maxLength"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { useDerivedState } from '@huse/derived-state';
import classNames from 'classnames';
import './index.less';
import OSUIInput from './Input';
var clsPrefix = 'osui-input'; // eslint-disable-next-line complexity

var InputWithCounter = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames, _props$style;

  var className = _ref.className,
      disabled = _ref.disabled,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      onChange = _ref.onChange,
      showCount = _ref.showCount,
      maxLength = _ref.maxLength,
      props = _objectWithoutProperties(_ref, _excluded);

  var initValue = defaultValue === undefined ? value || '' : defaultValue;

  var _useDerivedState = useDerivedState(initValue),
      _useDerivedState2 = _slicedToArray(_useDerivedState, 2),
      inputValue = _useDerivedState2[0],
      setInputValue = _useDerivedState2[1];

  var innerClassNames = classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-show-count"), showCount), _defineProperty(_classNames, "".concat(clsPrefix, "-show-count-with-max-length"), showCount && maxLength), _classNames), className);
  var handleChange = useCallback(function (e) {
    setInputValue(e.target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  }, [onChange, setInputValue]);
  var inputValueLength = (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) || 0;
  var showCountWithMaxLengthStyle = showCount && maxLength && ((_props$style = props.style) === null || _props$style === void 0 ? void 0 : _props$style.width) && {
    // 通过宽度-8px来固定位置
    width: "calc(".concat(props.style.width, "px - 8px)"),
    left: "-".concat(props.style.width || 0, "px"),
    // 这个用来固定文字，当由0变成10的时候不会抖动
    textAlign: 'right'
  } || {};
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OSUIInput, _objectSpread({
    ref: ref,
    className: innerClassNames,
    maxLength: maxLength,
    onChange: handleChange,
    value: inputValue
  }, props)), showCount && /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-show-count-counter"),
    style: showCountWithMaxLengthStyle
  }, maxLength ? "".concat(inputValueLength, " / ").concat(maxLength) : inputValueLength));
});
export default InputWithCounter;
//# sourceMappingURL=InputWithCounter.js.map